/**
 * Session flag for Always On matrix row reveal.
 * Reveal runs once per visit to the Always On channel; selection / paging /
 * tab switches must not replay it. Reset when leaving the Always On dashboard.
 */

let revealCompletedForVisit = false;

export function hasAlwaysOnRowRevealCompleted(): boolean {
  return revealCompletedForVisit;
}

export function markAlwaysOnRowRevealCompleted(): void {
  revealCompletedForVisit = true;
}

export function resetAlwaysOnRowReveal(): void {
  revealCompletedForVisit = false;
}
